<template>
  <div
    class="expand-y"
    :style="{ height: height + 'px' }"
  >
    <div
      ref="content"
      class="content"
    >
      <slot />
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ExpandY',
  components: { /* Subcomponents */ },
  props: ['open'],
  data() {
    return {
      elem: null,
      content: {},
      width: 0,
      height: 0,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    open(newState, oldState) {
      if (newState) this.expand();
      if (!newState) this.collapse();
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.elem = this.$refs['content'];
    this.getDimensions();
    this.setWidth();
  },
  updated() {

  },
  methods: {
    getDimensions() {
      this.content = {
        width: this.elem.offsetWidth,
        height: this.elem.offsetHeight,
      };
    },
    setWidth() {
      this.width = this.content.width;
    },
    expand() {
      this.height = this.content.height;
    },
    collapse() {
      this.height = 0;
    },
  },
};
</script>


<style scoped>
  .expand-y {
    position: relative;
    overflow: hidden;
    transition: height 0.5s ease;
    width: 100%;
    /* border: 2px dashed black; */
  }
  .content {
    position: absolute;
    width: 100%;
  }
</style>
